import { PLANOS_PAGOS } from "../components/PlanCards";

// Aviso de fim do teste grátis / da assinatura. No Android o aviso chega por
// push (Cloud Function verificarAssinaturas, todo dia às 08:00); aqui fica a
// regra do aviso local, usado no desktop/web onde não há push.

const DIA_MS = 86400000;
export const DIAS_AVISO_ASSINATURA = 3; // avisa nos últimos N dias

const paraData = (v) => (v?.toDate ? v.toDate() : v ? new Date(v) : null);

// Dias (arredondados pra cima) até acabar o teste/assinatura. null quando não
// se aplica: plano sem prazo (vitalício, pendente...), sem data, ou já venceu
// (aí a tela de plano expirado cuida).
export function diasParaAcabar(perfil, agora = Date.now()) {
  if (!perfil) return null;
  const ehTrial = perfil.plan === "trial";
  if (!ehTrial && !PLANOS_PAGOS.includes(perfil.plan)) return null;
  const fim = paraData(ehTrial ? perfil.trialEndsAt : perfil.planExpiresAt);
  if (!fim || Number.isNaN(fim.getTime())) return null;
  const restante = fim.getTime() - agora;
  return restante > 0 ? Math.ceil(restante / DIA_MS) : null;
}

// { dias, title, body, chave } quando é hora de avisar, senão null. A chave
// muda por dia restante e por data de fim, então dá pra mostrar cada aviso uma
// vez só (e recomeça sozinho depois de renovar, que muda a data de fim).
export function avisoAssinatura(perfil, agora = Date.now()) {
  const dias = diasParaAcabar(perfil, agora);
  if (dias === null || dias > DIAS_AVISO_ASSINATURA) return null;
  const ehTrial = perfil.plan === "trial";
  // Quem cancelou a renovação do plano pago já sabe que acaba (mesma regra do servidor).
  if (!ehTrial && perfil.autoRenewCancelled) return null;
  const fim = paraData(ehTrial ? perfil.trialEndsAt : perfil.planExpiresAt);
  const quando = dias <= 1 ? "em menos de 24 horas" : `em ${dias} dias`;
  return {
    dias,
    title: `⏳ ${ehTrial ? "Seu teste grátis" : "Sua assinatura"} acaba ${quando}`,
    body: ehTrial
      ? "Assine em Configurações → Plano pra não perder o acesso."
      : "Renove em Configurações → Plano pra continuar com acesso completo.",
    chave: `notif_assinatura_${perfil.plan}_${fim.toISOString().slice(0, 10)}_${dias}`,
  };
}
